"use strict";

const DropdownPort = {
  add: function (app) {
    // Handle outside click to close dropdown
    document.addEventListener("click", (event) => {
      const dropdown = event.target.closest(".dropdown");

      if (!dropdown) {
        if (app.ports.onDropdownOutsideClick) {
          app.ports.onDropdownOutsideClick.send("");
        }
        return;
      }

      // Clicked inside a dropdown, check if it's the toggle button
      const toggleButton = dropdown.querySelector(".dropdown-toggle");
      if (toggleButton && toggleButton.contains(event.target)) {
        // Toggle button clicked, let Elm handle it
        return;
      }

      // Clicked inside dropdown but not on toggle, don't close
      // (This allows clicking on dropdown items without closing)
    });

    // Handle escape key to close dropdown
    document.addEventListener(
      "keydown",
      function (event) {
        if (event.key === "Escape") {
          const dropdown = document.querySelector(".dropdown--open");
          if (dropdown) {
            event.stopPropagation();
            if (app.ports.onDropdownEscapeKeyPressed) {
              app.ports.onDropdownEscapeKeyPressed.send("");
            }
          }
        }
      },
      { capture: true },
    );
  },
};

module.exports = DropdownPort;
